import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  ToolbarPropsOverrides,
} from "@mui/x-data-grid-pro";
import React, { useEffect, useState } from "react";
import { useDataGridSettings } from "../DataGridSettingsProvider";
import { useOptionalViewContext } from "../ViewProvider";
import { AdminViewActions } from "./CustomToolbar/AdminViewActions";
import AdvancedSettingsDropdown from "./CustomToolbar/AdvancedSettingDropdown";
import HelpLinkButton from "./CustomToolbar/HelpLinkButton";
import { ResetViewOverrideButton } from "./CustomToolbar/ResetViewOverrideButton";
import SaveTableButton from "./CustomToolbar/SaveTableButton";
import { SaveViewOverrideButton } from "./CustomToolbar/SaveViewOverrideButton";
import TableTemplates from "./CustomToolbar/TableTemplates";
import { GridExportMenu } from "@/components/export/GridExportMenu";

const CustomToolbar = ({ report, fractionDigits, exportDisabled }: ToolbarPropsOverrides) => {
  const { pageType } = useDataGridSettings();
  const viewMode = !!useOptionalViewContext();
  const [showToolbarItems, setShowToolbarItems] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));

  useEffect(() => {
    setShowToolbarItems(!isMobile);
  }, [isMobile]);

  return (
    <GridToolbarContainer>
      {isMobile && (
        <IconButton
          onClick={() => setShowToolbarItems(!showToolbarItems)}
          size="small"
          sx={{ mr: 1 }}
        >
          {showToolbarItems ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      )}
      {showToolbarItems && (
        <>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridExportMenu
            report={report ?? { title: document.title || "export" }}
            fractionDigits={fractionDigits}
            disabled={exportDisabled}
          />
          {pageType !== "faultMonitor" && pageType !== "maintenance" && (
            <AdvancedSettingsDropdown />
          )}
          {viewMode ? (
            <>
              <SaveViewOverrideButton />
              <ResetViewOverrideButton />
              <AdminViewActions />
            </>
          ) : (
            <>
              <SaveTableButton />
              {pageType !== "maintenance" && <TableTemplates />}
            </>
          )}
          <HelpLinkButton />
          <Box sx={{ flexGrow: 1 }} />
          <GridToolbarQuickFilter />
        </>
      )}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
